<template>
  <div class="animated fadeIn">
    <template v-if="this.summary!=''">
    <div> Saudi arabia</div>
      <!-- Amir Processing -->
      <b-card header="Amir Processing">
        <b-row>
          <b-col sm="6" md="2" @click="viewReport(3,'okalawaiting','ksa')">
            <b-card class="text-white bg-info cursor_pointer">
              <div class="h4 mb-0">{{this.getData(3,'okalawaiting','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Waiting</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(3,'okala','ksa')">
            <b-card class="text-white bg-success cursor_pointer">
              <div class="h4 mb-0">{{this.getData(3,'okala','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Okala</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(3,'visa','ksa')">
            <b-card class="text-white bg-warning cursor_pointer">
              <div class="h4 mb-0">{{this.getData(3,'visa','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Visa</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(3,'manpower','ksa')">
            <b-card class="text-white bg-primary cursor_pointer">
              <div class="h4 mb-0">{{this.getData(3,'manpower','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Manpower</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(3,'delivery','ksa')">
            <b-card class="text-white bg-danger cursor_pointer">
              <div class="h4 mb-0">{{this.getData(3,'delivery','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Deliverd</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(3,'completed','ksa')">
            <b-card class="text-white bg-danger cursor_pointer">
              <div class="h4 mb-0">{{this.getData(3,'completed','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Completed</small>
            </b-card>
          </b-col>
          <!-- <b-col sm="6" md="2" >
            <b-card class="text-white bg-info cursor_pointer">
              <div class="h4 mb-0">{{amir_p_invoice-amir_p_invoice_due}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Income</small>
              <div class="h4 mb-0">{{amir_p_invoice_due}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Due</small>
            </b-card>
        </b-col> -->
        </b-row>
      </b-card>
      <!-- Amir Processing -->
      <!-- Amir Recuiting -->
      <b-card header="Amir Recruiting">
        <b-row>
          <b-col sm="6" md="2" @click="viewReport(2,'okalawaiting','ksa')">
            <b-card class="text-white bg-info cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'okalawaiting','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Waiting</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(2,'okala','ksa')">
            <b-card class="text-white bg-success cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'okala','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Okala</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(2,'visa','ksa')">
            <b-card class="text-white bg-warning cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'visa','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Visa</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(2,'manpower','ksa')">
            <b-card class="text-white bg-primary cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'manpower','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Manpower</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(2,'delivery','ksa')">
            <b-card class="text-white bg-danger cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'delivery','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Deliverd</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(2,'completed','ksa')">
            <b-card class="text-white bg-danger cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'completed','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Completed</small>
            </b-card>
          </b-col>
          <!-- <b-col sm="6" md="2" >
            <b-card class="text-white bg-info cursor_pointer">
              <div class="h4 mb-0">{{amir_r_invoice-amir_r_invoice_due}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Income</small>
              <div class="h4 mb-0">{{amir_r_invoice_due}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Due</small>
            </b-card>
          </b-col> -->
        </b-row>
      </b-card>
      <!-- Amir Recuiting -->
      <!-- Ruble profeccing -->
      <b-card header="Rubel Processing">
        <b-row>
          <b-col sm="6" md="2" @click="viewReport(1,'okalawaiting','ksa')">
            <b-card class="text-white bg-info cursor_pointer">
              <div class="h4 mb-0">{{this.getData(1,'okalawaiting','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Waiting</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(1,'okala','ksa')">
            <b-card class="text-white bg-success cursor_pointer">
              <div class="h4 mb-0">{{this.getData(1,'okala')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Okala</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(1,'visa','ksa')">
            <b-card class="text-white bg-warning cursor_pointer">
              <div class="h4 mb-0">{{this.getData(1,'visa','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Visa</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(1,'manpower','ksa')">
            <b-card class="text-white bg-primary cursor_pointer">
              <div class="h4 mb-0">{{this.getData(1,'manpower','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Manpower</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(1,'delivery','ksa')">
            <b-card class="text-white bg-danger cursor_pointer">
              <div class="h4 mb-0">{{this.getData(1,'delivery','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Deliverd</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(1,'completed','ksa')">
            <b-card class="text-white bg-danger cursor_pointer">
              <div class="h4 mb-0">{{this.getData(1,'completed','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Completed</small>
            </b-card>
          </b-col>
          <!-- <b-col sm="6" md="2">
            <b-card class="text-white bg-info cursor_pointer">
              <div class="h4 mb-0">{{rbl_p_invoice-rbl_p_invoice_due}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Income</small>
              <div class="h4 mb-0">{{rbl_p_invoice_due}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Due</small>
            </b-card>
          </b-col> -->
        </b-row>
      </b-card>
      <!-- Ruble profeccing -->
      <!-- Ruble Recuiting -->
      <b-card header="Rubel Recruiting">
        <b-row>
          <b-col sm="6" md="2" @click="viewReport(2,'okalawaiting','ksa')">
            <b-card class="text-white bg-info cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'okalawaiting','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Waiting</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(2,'okala','ksa')">
            <b-card class="text-white bg-success cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'okala','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Okala</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(2,'visa','ksa')">
            <b-card class="text-white bg-warning cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'visa','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Visa</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(2,'manpower','ksa')">
            <b-card class="text-white bg-primary cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'manpower','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Manpower</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(2,'delivery','ksa')">
            <b-card class="text-white bg-danger cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'delivery','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Deliverd</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(2,'completed','ksa')">
            <b-card class="text-white bg-danger cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'completed','ksa')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Completed</small>
            </b-card>
          </b-col>
          <!-- <b-col sm="6" md="2">
            <b-card class="text-white bg-info cursor_pointer">
              <div class="h4 mb-0">{{rbl_r_invoice-rbl_r_invoice_due}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Income</small>
              <div class="h4 mb-0">{{rbl_r_invoice_due}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Due</small>
            </b-card>
          </b-col> -->
        </b-row>
      </b-card>
      <!-- Ruble Recuiting -->

    <!-- Malaysia profeccing -->

    <div> Malaysia</div>
      
      <!-- Ruble profeccing -->
      <b-card header="Rubel Processing">
        <b-row>
          <b-col sm="6" md="2" @click="viewReport(1,'okalawaiting','myl')">
            <b-card class="text-white bg-info cursor_pointer">
              <div class="h4 mb-0">{{this.getData(1,'okalawaiting','myl')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Waiting</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(1,'okala','myl')">
            <b-card class="text-white bg-success cursor_pointer">
              <div class="h4 mb-0">{{this.getData(1,'okala','myl')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Okala</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(1,'visa','myl')">
            <b-card class="text-white bg-warning cursor_pointer">
              <div class="h4 mb-0">{{this.getData(1,'visa','myl')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Visa</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(1,'manpower','myl')">
            <b-card class="text-white bg-primary cursor_pointer">
              <div class="h4 mb-0">{{this.getData(1,'manpower','myl')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Manpower</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(1,'delivery','myl')">
            <b-card class="text-white bg-danger cursor_pointer">
              <div class="h4 mb-0">{{this.getData(1,'delivery','myl')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Deliverd</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(1,'completed','myl')">
            <b-card class="text-white bg-danger cursor_pointer">
              <div class="h4 mb-0">{{this.getData(1,'completed','myl')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Completed</small>
            </b-card>
          </b-col>
          <!-- <b-col sm="6" md="2">
            <b-card class="text-white bg-info cursor_pointer">
              <div class="h4 mb-0">{{rbl_p_invoice-rbl_p_invoice_due}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Income</small>
              <div class="h4 mb-0">{{rbl_p_invoice_due}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Due</small>
            </b-card>
          </b-col> -->
        </b-row>
      </b-card>
      <!-- Ruble profeccing -->
      <!-- Ruble Recuiting -->
      <b-card header="Rubel Recruiting">
        <b-row>
          <b-col sm="6" md="2" @click="viewReport(2,'okalawaiting','myl')">
            <b-card class="text-white bg-info cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'okalawaiting','myl')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Waiting</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(2,'okala','myl')">
            <b-card class="text-white bg-success cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'okala','myl')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Okala</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(2,'visa','myl')">
            <b-card class="text-white bg-warning cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'visa','myl')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Visa</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(2,'manpower','myl')">
            <b-card class="text-white bg-primary cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'manpower','myl')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Manpower</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(2,'delivery','myl')">
            <b-card class="text-white bg-danger cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'delivery','myl')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Deliverd</small>
            </b-card>
          </b-col>
          <b-col sm="6" md="2" @click="viewReport(2,'completed','myl')">
            <b-card class="text-white bg-danger cursor_pointer">
              <div class="h4 mb-0">{{this.getData(2,'completed','myl')}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Completed</small>
            </b-card>
          </b-col>
          <!-- <b-col sm="6" md="2">
            <b-card class="text-white bg-info cursor_pointer">
              <div class="h4 mb-0">{{rbl_r_invoice-rbl_r_invoice_due}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Income</small>
              <div class="h4 mb-0">{{rbl_r_invoice_due}}</div>
              <small class="text-muted text-uppercase font-weight-bold">Due</small>
            </b-card>
          </b-col> -->
        </b-row>
      </b-card>
      <!-- Ruble Recuiting -->

  </template>
    <WorkersReport ref="view_modal" :lists="lists"></WorkersReport>
  </div>
</template>

<script>
  import axios from "axios"
import WorkersReport from './dashboard/WorkersReport'
import { Callout } from '@coreui/vue'
import { mapState,mapGetters } from "vuex"
import { STATISTICS,SEARCH_LEADGER} from '@/store/action.type';
export default {
  name: 'dashboard',
  components: {
    WorkersReport,
  },
  data: function () {
    return {
      loader:false,
      summary_ksa:'',
      summary_myl:'',
    }
  },
  computed: {
      ...mapGetters(["leadgerdatas","statistics","authuser","user"]),
      
  },
  mounted(){
    this.getPermission();
    
    this.getKsaResults();
    this.getMylResults();
  },
  methods: {
    getPermission(){
        this.$store.dispatch('ALL_USER_ROLE2')
        .then(response=>{
            if(response.data.id!=2){
              this.getResults();
            }else{
              this.DataShow();
            }
        })
    },
    getData(type,status,country){
      var total = 0;
      if(country=='ksa'){
        
        if(status=='okalawaiting'){
          this.summary_ksa.okalawaiting.forEach(element => {
          
            if(element.type==type){
              total=element.total;
            }
          });
        }
        if(status=='okala'){
          this.summary_ksa.okala.forEach(element => {
            if(element.type==type){
              total=element.total;
            }
          });
        }
        if(status=='visa'){
          this.summary_ksa.visa.forEach(element => {
            if(element.type==type){
              total=element.total;
            }
          });
        }
        if(status=='manpower'){
          this.summary_ksa.manpower.forEach(element => {
            if(element.type==type){
              total=element.total;
            }
          });
        }
        if(status=='delivery'){
          this.summary_ksa.delivery.forEach(element => {
            if(element.type==type){
              total=element.total;
            }
          });
        }
        if(status=='completed'){
          this.summary_ksa.completed.forEach(element => {
            if(element.type==type){
              total=element.total;
            }
          });
        }
      }

      if(country=='ksa'){
        
        if(status=='okalawaiting'){
          this.summary_myl.okalawaiting.forEach(element => {
          
            if(element.type==type){
              total=element.total;
            }
          });
        }
        if(status=='okala'){
          this.summary_myl.okala.forEach(element => {
            if(element.type==type){
              total=element.total;
            }
          });
        }
        if(status=='visa'){
          this.summary_myl.visa.forEach(element => {
            if(element.type==type){
              total=element.total;
            }
          });
        }
        if(status=='manpower'){
          this.summary_myl.manpower.forEach(element => {
            if(element.type==type){
              total=element.total;
            }
          });
        }
        if(status=='delivery'){
          this.summary_myl.delivery.forEach(element => {
            if(element.type==type){
              total=element.total;
            }
          });
        }
        if(status=='completed'){
          this.summary_myl.completed.forEach(element => {
            if(element.type==type){
              total=element.total;
            }
          });
        }
      }
      return total;
      
    },
    viewReport(type,status,country){
      this.$refs.view_modal.openModal(type,status,country)
    },
    
    getKsaResults(){
          this.loader=true;
          axios.get("api/statistic-summary?country=KSA")
            .then(response => {
              this.summary_ksa = response.data;
              this.loader = false;
            })
            .catch(error => {
              this.loader=true;
            });

    },
    getMylResults(){
          this.loader=true;
          axios.get("api/statistic-summary?country=MYL")
            .then(response => {
              this.summary_myl = response.data;
              this.loader = false;
            })
            .catch(error => {
              this.loader=true;
            });

    },

  }
}
</script>

<style>
.cursor_pointer{
  cursor: pointer;
}
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
